// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".account-login-index .item-account[data-v-1b9a633c] {\n  position: relative;\n}\n.account-login-index .item-account .account-tip[data-v-1b9a633c] {\n  position: absolute;\n  right: 0;\n  bottom: -26px;\n}\n.account-login-index .item-account .account-tip p[data-v-1b9a633c] {\n  font-size: 14px;\n  font-weight: 400;\n  color: #067CFA;\n  line-height: 20px;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
